export default __webpack_public_path__ + "_/images/app/android/android-ru-3-8f2c68a78a3cc439adaef1818f700c6638671e8e67e1bd35abc045b32eb2ef41.png";